var productName = 'schedulerpro';export const stripDuplicates = (array) => Array.from(new Set(array));
